import React from 'react';

export default function FieldFormula_InlineValueEmpty(props:any) {

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default", "min-w-50", "fl-ac", "min-h-36", "p-l-10", "p-r-10", props.className)} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {props.field.placeholder}
            </div>
            {props.children}
        </React.Fragment>
    )

}
